<div class="workflow normal-text">
  <div class="scroll scrollbar">
    <h1 class='title'>{{ title | translate }}</h1>
    <h3 class='step'>{{ step | translate }}</h3>
    <teaser></teaser>
    <h2 *ngFor="let message of messages" class='information'>{{ message | translate }}</h2>
  </div>
</div>
